<template>
  <div class="NotificationTableComponent dataTables">
      <p>{{lang.infotext_2}}:</p>
        <div v-if="isData" id="place_notifications"></div>


        <LoaderComponent  v-if="!isData"></LoaderComponent>



    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import $ from 'jquery';
  import dt from 'datatables.net-bs4';
  import { mapGetters } from 'vuex'


    export default {
        name: "NotificationTableComponent",
        props:{
          lang: Object
        },
        components: {

          LoaderComponent
        },
        data () {
            return {

                mainTable: ""

            }
        },
        computed: {
          id () {

            return "place_notifications";
          },
          dataTable () {

            return this.$store.getters.dataNotifications
          },
          isData(){
            return Object.keys(this.$store.getters.dataNotifications).length != 0
          }
        },

        created () {
          console.log("created table notifications")

          this.$store.dispatch('getNotifications');

        },
        watch: {

        },
        updated() {
          console.log("updated table notifications")

          this.buildTable();
        },
        methods: {

          buildTable(){
            console.log("buildTable notifications")



            var tableplace = document.getElementById(this.id);

            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_"+this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var cols = [];
            var header = "";
            var columnDefs = [];
            var len = this.dataTable.columns.length;
            for (var i = 0; i < len; i++){




              var el = {};
              if (this.dataTable.columns[i].dataObject == 1){
                el = {
                      targets: i,
                      className: '_dt-body-'+ this.dataTable.columns[i].alignInColumn,

                      render: function ( data, type, row, meta ) {
                        if (data == null) {
                          data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                          data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                          if (type === 'display') {
                            if (data.display != ""){
                              if (meta.settings.oInit.myColumnFormats[meta.col].type == "icons"){

                                  return "<img src='/static/"+data.display+".png'>";


                              }else if (meta.settings.oInit.myColumnFormats[meta.col].type == "badges"){
                                return "<b-badge class='badge badge-"+data.variant+" '>"+data.display+"</b-badge>"
                              }else if (meta.settings.oInit.myColumnFormats[meta.col].type == "text"){

                                if (data.new == true){
                                  return "<b>a"+data.display+"</b>";
                                }

                              }

                            }else{
                              return ""
                            }
                          }
                          else if (type === 'filter') {
                            return data.filter;
                          }
                          else if (type === 'sort'){
                            return data.sort;
                          }

                          return data;

                      }

                    }


                columnDefs.push(el);
              }else{
                el = {
                      targets: i,
                      className: '_dt-body-'+ this.dataTable.columns[i].alignInColumn
                    }

                columnDefs.push(el);
              }

              var obj = {"Name": this.dataTable.columns[i].name}
              cols.push(obj);

              var th = document.createElement("th");
              tr.appendChild(th);
              var br = document.createElement("br");
              th.appendChild(br);

              var tx = document.createTextNode(this.dataTable.columns[i].name)
              th.appendChild(tx);



            }


            var _p = this;




            var json = {};

            json.paging = false;
            json.info = false;
            json.dom = 'f<t>';
            json.data= this.dataTable.data;
            json.myColumnFormats = this.dataTable.columns;
            json.select = true;
            json.sort

            json.columns = cols;

            json.columnDefs = columnDefs;

            json.render = {function(data, type, row){
              console.log(data)
              return data+" (out of service)";
            }, "targets": 1 };


            if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
                this.mainTable.destroy();
                console.log("DESTROY TABLE")
            }

            this.mainTable = $('#t_'+this.id).DataTable(json);

            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column( 0 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }
            searchplace.firstChild.setAttribute("placeholder", "Search...");
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")
            //searchplace.firstChild.setAttribute("class", "searcher");

            $("#t_"+this.id +" tbody").on('dblclick', 'tr', function () {
            
                var index = this._DT_RowIndex;


                _p.goTo(index);

            });
          },
          goTo: function (index){

            var rowData = {"0":[{key:this.$store.getters.dataNotifications.data[index][0].key}]}//[{[{key:this.$store.getters.dataNotifications.data[index][0].key}]}]

            this.$store.dispatch("deleteAllSelectedRows")
            this.$store.dispatch("setSelectedRows",rowData);


            this.$store.dispatch("hideAlert");


            let to = this.$store.getters.dataNotifications.data[index][0].to;

  

            

            const query = {
              from: this.$route.path,
              to: to,
              key: this.$store.getters.dataNotifications.data[index][0].key
            }

            this.$router.push({ path: to, query: query });
            }
        }


    }
</script>
<style >
  .NotificationTableComponent table{
    font-size: 0.75rem;

    padding: 0px !important;
  }
  .NotificationTableComponent table th {
    padding: 0rem !important;

  }
  .NotificationTableComponent table td {
    padding: 0rem !important;

  }
  .NotificationTableComponent .progress{
    width: 200px;

  }
  .NotificationTableComponent .dataTables_filter{
    font-size: 10px;
  }
  .NotificationTableComponent .searcher{
    float: left;
  }
  .NotificationTableComponent .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
    padding: 0.1rem 0.1rem;
    font-size: 0.7rem;
    line-height: 1;
    width: 200px;
  }
  .NotificationTableComponent ._dt-body-left{
    text-align: left;
  }
  .NotificationTableComponent ._dt-body-right{
    text-align: right;
  }
  .NotificationTableComponent ._dt-body-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/NotificationTableComponent.vue